import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { ClientSettingsService } from 'src/app/services/client-settings.service';
import { SessionTimeoutService } from 'src/app/services/session-timeout.service';
import { ClientSettingsResponse } from 'src/app/shared/models/appsettings.model';
import { UserSettingData } from '../home/dashboard-widgets/models/dashboard.model';
import { UserContextService } from 'src/app/services/user-context.service';

@Component({
    selector: 'app-base-welcome',
    templateUrl: './base-welcome.component.html',
    styleUrl: './base-welcome.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class BaseWelcomeComponent implements OnInit,OnDestroy {
    userSettingsData: UserSettingData;
    welcomeLayout: any;
    _unsubscribe: any = [];
    isIframe: boolean;
    currentDateStr: string = new Date().getFullYear().toString();
    userInfo: any = null;
    isWelcomePage: boolean = true;
    isLoading:boolean = false;
    ShowFooterAcrossAllPages: string;
    clientSettings: any;
    get isPageRedirect():boolean{
        let val = localStorage.getItem("isLoginInprogress");
        if(val == "true"){
            this.router.navigate['loggedin'];
            return true;
        }else{
            return false;
        }
    };


    constructor(
        private _clientSettingsService: ClientSettingsService,
        private router: Router,
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private authService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        private sessionTimeoutService: SessionTimeoutService,
        private cdref: ChangeDetectorRef,
        private _sanitizer: DomSanitizer,
        private _userContextService: UserContextService
    ) {
        this.userInfo = this.authService.instance.getActiveAccount();
        const url = router.url;
        if (url.toLowerCase().includes('xero') || url.toLowerCase().includes('quickbooks') || url.toLowerCase().includes('cpv') || url.toLowerCase().includes('pricingapi')) {
            this.isWelcomePage = false
        }
        if (this.userInfo?.idToken) {
            router.navigate['loggedin'];
        }
    }
    loginRedirect() {
        //sessionStorage.setItem("isLoginInprogress","true")
        if (this.msalGuardConfig.authRequest) {
            this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
        } else {
            this.authService.loginRedirect();
        }
    }

    ngOnInit(): void {
        // sessionStorage.clear();
        let subscription =  this._userContextService.isLoading$.subscribe((loadingState) => {
            this.isLoading = loadingState;
          });
        this.getClientSettings();
         subscription = this._clientSettingsService.getData().subscribe((data: Partial<ClientSettingsResponse>) => {
            this.userSettingsData = data.Data as UserSettingData;
            this.ShowFooterAcrossAllPages = data.Data.ShowFooterAcrossAllPages;
        });

        const welcomeLayoutObservable = this._clientSettingsService.getWelcomeLayout().subscribe(({ Data }: any) => {
            this.welcomeLayout = this._sanitizer.bypassSecurityTrustHtml(Data.Value);
        });

        this._unsubscribe.push(welcomeLayoutObservable);

        this.isIframe = window !== window.parent && !window.opener; // Remove this line to use Angular Universal
        this._unsubscribe.push(subscription);
    }

    getClientSettings() {
        this._clientSettingsService.getData().subscribe((response: any) => {
            this.clientSettings = response.Data;
        })
    }

    logout(popup?: boolean) {
        this._userContextService.setLoading(false);
        if (popup) {
            this.authService.logoutPopup({ mainWindowRedirectUri: "/welcome" });
        } else {
            this.authService.logoutRedirect();
        }
    }

    goToContactUs() {
        if (this.clientSettings?.LinkToContact === "/#/contact/" || this.clientSettings?.LinkToContact === "/contact") {
            window.open(this.clientSettings?.LinkToContact, "_blank");
        }
        else {
            window.open(this.clientSettings?.LinkToContact, "_blank");
        }
    }


    login() {
        // clear off previous impersonation context, if any
        localStorage.removeItem("impersonationContext");
        localStorage.removeItem("resellerImpersonationContext");
        localStorage.removeItem("planContext");
        window.localStorage.clear();
        this.loginRedirect();
        /* KB 11/30: On iOS - loginRedirect has an issue while saving the token to the local storage */
        // if (!$rootScope.isiOS) {
        //     msalService.loginRedirect();
        // }
        // else {
        //     msalService.loginPopup();
        // }
    }
  ngOnDestroy(): void {
      this._userContextService.setLoading(false);
  }
}
